import React from 'react';
import { TextField, FormControlLabel, Switch } from '@mui/material';

interface GrouperFormFieldsProps {
    code: string;
    rate: number;
    isPerDiem: boolean;
    codeError?: string;
    rateError?: string;
    onCodeChange: (value: string) => void;
    onRateChange: (value: number) => void;
    onIsPerDiemChange: (value: boolean) => void;
}

export const GrouperFormFields: React.FC<GrouperFormFieldsProps> = ({
    code,
    rate,
    isPerDiem,
    codeError,
    rateError,
    onCodeChange,
    onRateChange,
    onIsPerDiemChange
}) => {
    return (
        <>
            <TextField
                label="Code"
                value={code}
                onChange={(e) => onCodeChange(e.target.value)}
                error={!!codeError}
                helperText={codeError}
                fullWidth
                size="small"
            />
            <TextField
                label="Rate"
                type="number"
                value={rate}
                onChange={(e) => onRateChange(parseFloat(e.target.value) || 0)}
                error={!!rateError}
                helperText={rateError}
                inputProps={{ min: 0, step: 0.01 }}
                fullWidth
                size="small"
            />
            <FormControlLabel
                control={
                    <Switch
                        checked={isPerDiem}
                        onChange={(e) => onIsPerDiemChange(e.target.checked)}
                    />
                }
                label="Per Diem"
            />
        </>
    );
};
